import React from "react";
import { SvgIcon } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  icon: {
    width: 39,
    height: 35
  }
}));

export default function DefaultAnnouncementIcon() {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <SvgIcon viewBox="0 0 24 24" className={classes.icon}>
      <svg
        id="svg"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0, 0, 400,400"
      >
        <defs>
          <linearGradient id="primaryGrad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#5363C6" stopOpacity={1} />
            <stop
              offset="#262262"
              stopColor={theme.palette.secondary.main}
              stopOpacity={1}
            />
          </linearGradient>
        </defs>
        <g id="svgg">
          <path
            id="path0"
            d="M43.735 28.186 C 30.583 32.402,20.603 44.372,18.844 58.039 C 18.380 61.649,18.078 127.413,18.063 228.232 
            L 18.039 392.543 54.709 355.879 L 91.379 319.216 222.470 319.216 C 350.547 319.216,353.675 319.180,358.545 
            317.675 C 368.450 314.614,376.199 307.862,381.034 298.080 L 383.922 292.239 384.131 174.943 C 384.337 
            59.462,384.316 57.567,382.767 52.455 C 379.654 42.183,372.473 34.185,361.936 29.251 L 357.255 27.059 
            202.745 26.901 C 54.644 26.750,48.049 26.803,43.735 28.186 M219.608 136.078 L 219.608 190.588 201.569 
            190.588 L 183.529 190.588 183.523 171.569 C 183.520 161.108,183.287 136.578,183.005 117.059 L 182.494 
            81.569 201.051 81.569 L 219.608 81.569 219.608 136.078 M219.608 245.882 L 219.608 264.314 201.569 
            264.314 L 183.529 264.314 183.529 245.882 L 183.529 227.451 201.569 227.451 L 219.608 227.451 219.608 245.882 "
            stroke="none"
            fill="url(#primaryGrad)"
          ></path>
        </g>
      </svg>
    </SvgIcon>
  );
}
